export { PHProvider } from './PosthogProvider'
